// httpPorts — the Brief slice: plan a document, make one from sources,
// and a container's export readiness, over the command bus. Every
// reply is parsed at this boundary.

import { Result } from "@bilda/utils";
import { mkMalformed } from "../externalError.js";
import type { BriefPorts } from "../ports/brief.js";
import { parseExportReadiness } from "../readinessAdapter.js";
import { fields, str } from "../wireShape.js";
import { command } from "./shared.js";

export const briefHttp: BriefPorts = {
    planDocument: async (containerId, title, brief, kind) => {
        const r = await command("planDocument", {
            container: containerId,
            title,
            brief,
            ...(kind === undefined ? {} : { kind }),
        });
        if (Result.isErr(r)) return r;
        const documentId = str(fields(r.value)?.get("document"));
        return documentId === undefined
            ? Result.err(mkMalformed("planDocument returned no document id"))
            : Result.ok({ containerId, documentId });
    },
    createFromSources: async ({ from, what, where, title, project }) => {
        const r = await command("createFromSources", {
            from,
            what,
            ...(where === undefined ? {} : { where }),
            ...(title === undefined ? {} : { title }),
            ...(project === undefined ? {} : { project }),
        });
        if (Result.isErr(r)) return r;
        const f = fields(r.value);
        const material = str(f?.get("material"));
        const container = str(f?.get("container"));
        return material === undefined || container === undefined
            ? Result.err(mkMalformed("createFromSources returned no material"))
            : Result.ok({ material, container });
    },
    planPart: async ({ project, part, title, focus }) => {
        const r = await command("planPart", {
            project,
            part,
            title,
            ...(focus === undefined ? {} : { focus }),
        });
        if (Result.isErr(r)) return r;
        const f = fields(r.value);
        const made = str(f?.get("part"));
        const place = fields(f?.get("place"));
        return made === undefined || place === undefined
            ? Result.err(mkMalformed("planPart returned no part"))
            : Result.ok({
                  part: made,
                  container:
                      str(place.get("type")) === "end_of_container"
                          ? str(place.get("container"))
                          : undefined,
              });
    },
    loadExportReadiness: async (containerId) => {
        const r = await command("exportReadiness", { containerId });
        return Result.isErr(r) ? r : parseExportReadiness(r.value);
    },
};
